import { FormFieldTypes, validationTypes } from "@repo/design-system/components/forms/libs";

export const buildCollegeAcademicRecordFormConfig = () => ({
  name: "College Academic Record Form",
  initialState: {
    universityId: "",
    instituteId: "",
    seatNo: "",
    passingYear: "",
    cgpa: "",
  },
  section: [
    {
      title: "",
      style: { sectionStyle: "" },
      rowGroup: [
        {
          style: { groupStyle: "row" },
          fields: [
            {
              id: "universityId",
              label: "University Name",
              Field_Name: "University Name",
              // Paged + searchable (same as institute) — loads the next page on scroll
              fieldType: FormFieldTypes.LAZY_SELECT,
              dataField: "universityId",
              fieldSetting: { placeholder: "Select university name", isSearchable: true },
              validation: [{ type: validationTypes.REQUIRE }],
              style: { containerCss: "col-6 mb-2" },
            },
            {
              id: "instituteId",
              label: "Institute Name",
              Field_Name: "Institute Name",
              // Institute list runs into the thousands — this fetches/searches it a page at a time
              // instead of a plain SELECT's fully-loaded options list.
              fieldType: FormFieldTypes.LAZY_SELECT,
              dataField: "instituteId",
              fieldSetting: { placeholder: "Select institute name", isSearchable: true },
              validation: [{ type: validationTypes.REQUIRE }],
              style: { containerCss: "col-6 mb-2" },
            },
          ],
        },
        {
          style: { groupStyle: "row" },
          fields: [
            {
              id: "seatNo",
              label: "Enrollment No",
              Field_Name: "Enrollment No",
              fieldType: FormFieldTypes.INPUT,
              dataField: "seatNo",
              fieldSetting: { placeholder: "Enter enrollment no", maxLength: 30 },
              validation: [{ type: validationTypes.REQUIRE }],
              style: { containerCss: "col-6 mb-2" },
            },
            {
              id: "passingYear",
              label: "Passing Year",
              Field_Name: "Passing Year",
              fieldType: FormFieldTypes.SELECT,
              dataField: "passingYear",
              fieldSetting: { placeholder: "Select passing year", options: [], isSearchable: true },
              validation: [{ type: validationTypes.REQUIRE }],
              style: { containerCss: "col-6 mb-2" },
            },
          ],
        },
        {
          style: { groupStyle: "row" },
          fields: [
            {
              id: "cgpa",
              label: "CGPA",
              Field_Name: "CGPA",
              fieldType: FormFieldTypes.NUMERIC,
              dataField: "cgpa",
              fieldSetting: { placeholder: "Enter CGPA", masked: { format: "0.00" } },
              validation: [{ type: validationTypes.REQUIRE }],
              style: { containerCss: "col-6 mb-2" },
            },
          ],
        },
      ],
    },
  ],
});
